import { useQuery } from "react-query";
import axios from "infra/http";
import {GetEncargosResponse} from '../typings';

function useFindContaEncargos(id: string | undefined, dataCalculo?: string, enabled?: boolean) {
  return useQuery(
    [`/v1/conta/${id}/encargos`, dataCalculo],
    async () => {
      const { data } = await axios.get<GetEncargosResponse>(`/v1/conta/${id}/encargos`, {
        params: {
          dataCalculo
        }
      });

      return data;
    },
    {
      enabled: !!id && enabled,
    }
  );
}

export default useFindContaEncargos;
